import React, { useState } from 'react';
import { Grid, GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import { useIsomorphicLayoutEffect } from '@/hooks/useIsomorphicLayoutEffect';
import appConfig from '../../config/app.json'; // Resolve can't fix this. It's a bug in eslint-plugin-import
import * as S from './styled';
import HubBody from './HubBody';

const HubContent = ({ data }) => {
  const [scroll, setScroll] = useState(false);
  const { name } = data;

  useIsomorphicLayoutEffect(() => {
    const handleScroll = () => {
      const hiddenElementHeight = document.querySelector(
        '#brandHubDescription'
      ).offsetHeight;
      const newState =
        window.scrollY - hiddenElementHeight > appConfig.layout.hubHeight;
      if (newState !== scroll) {
        window.dispatchEvent(new CustomEvent('brandHubResize'));
        setScroll(newState);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scroll]);

  return (
    <S.BrandHub aria-label={`Informatie-gedeelte van ${name}`} id="BrandHub">
      <Grid>
        <GridItem columnStartSm="1" columnEndSm="span 12">
          <S.BrandWrapper>
            <HubBody mobileHide={scroll} data={data} />
          </S.BrandWrapper>
        </GridItem>
      </Grid>
    </S.BrandHub>
  );
};

export default HubContent;

HubContent.defaultProps = {
  data: {
    logoUrl: null,
  },
};

HubContent.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    logoUrl: PropTypes.string,
    slug: PropTypes.string.isRequired,
  }),
};
